import React, { FunctionComponent } from 'react'
import { BrowserRouter } from 'react-router-dom'
import AppProvider from './modules/auth/hooks'
import FrotistaProvider from './modules/user/hooks'
import Routes from './shared/routes'
import GlobalStyle from './shared/styles/global'

const App: FunctionComponent = () => {
  return (
    <BrowserRouter>
      <AppProvider>
        <FrotistaProvider>
          <Routes />
        </FrotistaProvider>
      </AppProvider>
      <GlobalStyle />
    </BrowserRouter>
  )
}

export default App
